// extracted by mini-css-extract-plugin
export default {"info-block":"InfoBlock_info-block__FxorF","info-block-item":"InfoBlock_info-block-item__FuuOR"};